
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M10.608 2a.75.75 0 00-1.5 0v7.43a.75.75 0 101.5 0V2zM7.822 5.384a.75.75 0 10-.5-1.414 7.608 7.608 0 105.072 0 .75.75 0 00-.5 1.414 6.108 6.108 0 11-4.072 0z"}})])
          )
        }
      }
    